import {
    activeSellerActions,
    soldActions,
    unsoldActions
} from '../../helpers/item-actions-helper-seller';
import {
    activeBuyerActions,
    boughtActions,
    lostActions
} from '../../helpers/item-actions-helper-buyer';
import { PAGE_NAMES } from '../../constants/page';
import logger from 'packages/logger';

export const getActionsForItem = (
    item,
    listViewType,
    memberId,
    memberMessagingParticipation,
    pageName
) => {
    const secondaryActions = [];
    let primaryAction = null;

    const checkAndAdd = action => {
        try {
            if (!action.isVisible) {
                throw 'Action is not compatible: ' + action.label;
            }
            if (!action.isVisible()) {
                return;
            }
            if (primaryAction === null && action.isPrimaryAction()) {
                primaryAction = action;
            } else {
                secondaryActions.push(action);
            }
        } catch (error) {
            logger(error);
        }
    };

    const resolveActions = potentialActions => {
        potentialActions.forEach(actionCreator => {
            const action = actionCreator();
            checkAndAdd(action);
        });
        return {
            primaryAction,
            secondaryActions
        };
    };

    let actionsForItem = [];
    switch (pageName) {
        case PAGE_NAMES.BuyerActiveItems:
            actionsForItem = resolveActions(
                activeBuyerActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.BuyerPurchases:
            actionsForItem = resolveActions(
                boughtActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.BuyerItemsLost:
            actionsForItem = resolveActions(lostActions(item, listViewType));
            break;
        case PAGE_NAMES.SellerSold:
            actionsForItem = resolveActions(
                soldActions(
                    item,
                    listViewType,
                    memberId,
                    memberMessagingParticipation
                )
            );
            break;
        case PAGE_NAMES.SellerUnsold:
            actionsForItem = resolveActions(
                unsoldActions(item, listViewType, memberId)
            );
            break;
        case PAGE_NAMES.SellerActive:
            actionsForItem = resolveActions(
                activeSellerActions(
                    item,
                    listViewType,
                    memberId,
                    memberMessagingParticipation
                )
            );
            break;
        default:
            throw 'Actions for item and pageName ' +
                pageName +
                ' is not defined';
    }
    return actionsForItem;
};
